import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { BellRinging, BellSlash } from "@phosphor-icons/react";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export default function PushCard() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const supported = "serviceWorker" in navigator && "PushManager" in window;

  useEffect(() => {
    api.get("/push/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  const enable = async () => {
    setBusy(true);
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") { toast.error("Разрешите уведомления в браузере"); setBusy(false); return; }
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(status.public_key),
      });
      await api.post("/push/subscribe", {
        subscription: sub.toJSON(),
        tz_offset_min: -new Date().getTimezoneOffset(),
      });
      setStatus((s) => ({ ...s, subscribed: true }));
      toast.success("Уведомления включены");
    } catch (e) {
      toast.error("Не удалось включить уведомления");
    }
    setBusy(false);
  };

  const disable = async () => {
    setBusy(true);
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      if (sub) await sub.unsubscribe();
      await api.post("/push/unsubscribe");
      setStatus((s) => ({ ...s, subscribed: false }));
      toast.success("Уведомления выключены");
    } catch {}
    setBusy(false);
  };

  if (!status?.configured) return null;

  return (
    <div className="glass-card p-5" data-testid="push-card">
      <div className="flex items-center gap-2 mb-2">
        {status.subscribed
          ? <BellRinging size={18} weight="fill" className="text-[#00e676]" />
          : <BellSlash size={18} className="text-muted-foreground" />}
        <h3 className="text-sm font-semibold">Умные уведомления</h3>
      </div>
      <p className="text-xs text-muted-foreground mb-3">
        Утренний «Фокус дня» с рекомендацией (тренироваться или восстанавливаться), напоминание о золотом окне отбоя и предупреждение о признаках болезни — прямо на телефон.
      </p>
      {!supported ? (
        <p className="text-xs text-muted-foreground" data-testid="push-unsupported">Ваш браузер не поддерживает push-уведомления.</p>
      ) : status.subscribed ? (
        <Button size="sm" variant="outline" onClick={disable} disabled={busy} data-testid="push-disable-button">
          <BellSlash size={14} className="mr-1.5" /> Выключить
        </Button>
      ) : (
        <Button size="sm" onClick={enable} disabled={busy} data-testid="push-enable-button">
          <BellRinging size={14} weight="fill" className="mr-1.5" /> Включить уведомления
        </Button>
      )}
    </div>
  );
}
